export default __webpack_public_path__ + "static/media/RealtyExecutives.d6df6a5d.jpg";